import { configureMinicartStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
import MenuWrapper from './MenuWrapper';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import cookie from 'react-cookies';
import useHeaderRef from '@stone/hooks/useHeaderRef';
gsap.registerPlugin(ScrollTrigger);
const store = configureMinicartStore();
const markers = cookie.load('gsap_markers');
const MenuLoader = (props) => {
    const headerRef = useHeaderRef(props.isPdp);
    // const [isPdp, setIsPdp] = useState(props.isPdp);
    // const progressTime = useRef(0);
    // const progressScroll = useRef(0);
    // useEffect(() => {
    //   customEventBus.on('header:setpdp', (data: { isPdp: boolean }) => {
    //     setIsPdp(data.isPdp);
    //   });
    //   return () => {
    //     customEventBus.off('header:setpdp', () => {setIsPdp(data.isPdp);});
    //   };
    // }, []);
    // useEffect(() => {
    //   if (!headerRef.current) {
    //     return;
    //   }
    //   const observer = new ResizeObserver((entries) => {
    //     const entry = entries[0];
    //     setHeaderHeight(entry.contentRect.height);
    //   });
    //   observer.observe(headerRef.current);
    //   return () => observer.disconnect();
    // }, []);
    // useEffect(() => {
    //   const handleScroll = () => {
    //     const scrollY = window.scrollY;
    //     const scrollDifference = scrollY - lastScrollY;
    //     let _headerOffset;
    //     if (scrollDifference > 0) {
    //       // Scroll down: nascondi l'header gradualmente
    //       _headerOffset = Math.min(headerOffset + scrollDifference, headerHeight);
    //     } else {
    //       // Scroll up: mostra l'header gradualmente
    //       _headerOffset = Math.max(headerOffset + scrollDifference, 0);
    //     }
    //     gsap.set(headerRef.current.parentElement, {
    //       y: -_headerOffset,
    //     });
    //     setHeaderOffset(_headerOffset);
    //     setLastScrollY(scrollY);
    //   };
    //   window.addEventListener('scroll', handleScroll);
    //   return () => {
    //     window.removeEventListener('scroll', handleScroll);
    //   };
    // }, [lastScrollY, headerHeight, headerOffset]);
    // useGSAP(
    //   (context, contextSafe) => {
    //     // const handleAnimation = contextSafe(() => {
    //     //   const map = gsap.utils.mapRange(1, 0, headerRef.current.getBoundingClientRect().height, 0, progressTime.current);
    //     //   const tl = gsap.timeline();
    //     //   tl.to(headerRef.current.parentElement, { y: '-101%', ease: 'linear' });
    //     //   ScrollTrigger.create({
    //     //     id: 'header-animation',
    //     //     markers: markers && {
    //     //       indent: 100,
    //     //     },
    //     //     start: () => `clamp(top-=${map} top)`,
    //     //     end: () => `+=${headerRef.current.parentElement.getBoundingClientRect().height}`,
    //     //     trigger: headerRef.current,
    //     //     onUpdate: (self) => {
    //     //       progressTime.current = self.progress;
    //     //       customEventBus.emit('header:setheight', {
    //     //         height: headerRef.current.parentElement.getBoundingClientRect().height,
    //     //       });
    //     //       const check = window.scrollY >= headerRef.current.parentElement.getBoundingClientRect().height;
    //     //       console.log('HEADER', gsap.utils.mapRange(1, 0, 0, 1, self.progress));
    //     //       customEventBus.emit('header:onprogress', {
    //     //         scroll: check ? gsap.utils.mapRange(1, 0, 0, 1, self.progress) : 0,
    //     //       });
    //     //     },
    //     //     onLeave: () =>
    //     //       customEventBus.emit('header:onprogress', {
    //     //         scroll: 0,
    //     //       }),
    //     //     scrub: true,
    //     //     animation: tl,
    //     //   });
    //     // });
    //     const handleTransparency = contextSafe(() => {
    //       const hero = document.querySelector('[data-hero-scroll="true"]');
    //       if (!!hero) {
    //         ScrollTrigger.create({
    //           id: 'header-transparency',
    //           trigger: hero,
    //           markers: markers && {
    //             indent: 800,
    //           },
    //           // start: () => `clamp(top+=${!!hero ? hero?.clientHeight : headerRef.current.clientHeight} top)`,
    //           // end: () => `clamp(top+=${!!hero ? hero?.clientHeight : headerRef.current.clientHeight} top)`,
    //           start: 'bottom top',
    //           end: 'bottom top',
    //           onEnter: () => {
    //             customEventBus.emit('header:settrasparency', { transparent: false, color: 'black' });
    //           },
    //           onEnterBack: () => {
    //             customEventBus.emit('header:settrasparency', { transparent: true, color: 'white' });
    //           },
    //         });
    //       } else {
    //         ScrollTrigger.getById('header-transparency')?.kill();
    //         customEventBus.emit('header:settransparency', {
    //           transparent: false,
    //           color: 'black',
    //         });
    //       }
    //     });
    //     const startAnimation = contextSafe(() => {
    //       ScrollTrigger.addEventListener('scrollEnd', startAnimation);
    //       ScrollTrigger.getById('header-animation')?.kill();
    //       progressScroll.current = window.scrollY;
    //       // handleAnimation();
    //       const transScroller = ScrollTrigger.getById('header-transparency');
    //       if (transScroller) {
    //         transScroller.update();
    //       } else {
    //         handleTransparency();
    //       }
    //       ScrollTrigger.getAll()?.forEach((el) => el.refresh());
    //     });
    //     const quitAnimation = contextSafe(() => {
    //       ScrollTrigger?.removeEventListener('scrollEnd', startAnimation);
    //       // ScrollTrigger.getById('header-animation')?.kill();
    //       ScrollTrigger.getById('header-transparency')?.kill();
    //     });
    //     if (headerRef.current) {
    //       startAnimation();
    //       customEventBus.on('header:quitanimation', quitAnimation);
    //       customEventBus.on('header:updatescroll', startAnimation);
    //     }
    //     return () => {
    //       quitAnimation();
    //     };
    //   },
    //   { scope: headerRef }
    // );
    return (React.createElement(Provider, { store: store },
        React.createElement("div", { ref: headerRef, className: "header-transition" },
            React.createElement(MenuWrapper, Object.assign({}, props)))));
};
export default MenuLoader;
